import * as React from 'react';

import { twMerge } from 'tailwind-merge';

import { TFloatingLabel, baseVariants } from './types';

export const FloatingLabel: React.FC<TFloatingLabel> = ({
  description,
  disabled,
  isInvalid,
  variant,
  className,
  placeholder,
  classNames = {},
  endContent,
  size = 'default',
  children,
  triggerClassName,
  isFocused,
  ...props
}) => {
  return (
    <div className={twMerge('w-full', className)}>
      <label
        className="group w-full min-w-0"
        data-has-label={Boolean(placeholder) && size !== 'sm'}
        data-filled-within={isFocused}
        {...props}
      >
        <div
          data-is-invalid={Boolean(isInvalid)}
          data-disabled={Boolean(disabled)}
          className={twMerge(
            baseVariants({ variant, size, disabled, isInvalid }),
            classNames.wrapper,
            triggerClassName,
          )}
        >
          {placeholder && size !== 'sm' && (
            <span
              className={twMerge(
                'pointer-events-none absolute origin-top-left truncate rtl:origin-top-right',
                'text-left text-[16px] leading-[20px] text-base-300',
                'inset-x-[14px] shrink-0',
                'transition-transform duration-200 ease-out will-change-auto',
                size === 'default' &&
                  'group-data-[filled-within=true]:-translate-y-[9px] group-data-[filled-within=true]:scale-[0.9]',
                size === 'md' &&
                  'group-data-[filled-within=true]:-translate-y-[7px] group-data-[filled-within=true]:scale-[0.7]',
                classNames.placeholder,
              )}
            >
              {placeholder}
            </span>
          )}
          <div
            className={twMerge(
              'flex h-full w-full min-w-0 flex-1 items-center overflow-hidden group-data-[has-label=true]:items-end',
              size === 'default' && Boolean(placeholder) && 'pb-1',
            )}
          >
            {children}
          </div>
          {endContent && (
            <div className="flex shrink-0 items-center justify-center">
              {endContent}
            </div>
          )}
        </div>
      </label>

      {description && (
        <p
          className={twMerge(
            'mt-2 px-[14px] typography-12r',
            'text-base-300',
            classNames.description,
          )}
        >
          {description}
        </p>
      )}
    </div>
  );
};
